import React, { ChangeEvent, useEffect, useState } from 'react';
import { MovingInFinishDto } from '../../../services/dtos/moving-in-finish.dto';
import MovingInStepTwoForm from '../../../components/forms/moving-in/moving-in-step-two/moving-in-step-two.form';
import { useNavigate } from 'react-router-dom';

/**
 * Page étape 2 j'emménage
 * @constructor
 */
export default function MovingInStepTwoPage() {
    //use state
    const navigate = useNavigate();
    const [isOwner, setIsOwner] = useState<string>('');
    const [newAddress, setNewAddress] = useState<string>();
    const [validForm, setValidForm] = useState<boolean>(true);
    const infosMovingIn = window.localStorage.getItem('movingInFinish');
    //Permet de controller les champs, il faudrait faire des composants radio maison
    const [isOwnerError, setIsOwnerError] = useState<boolean>(false);

    useEffect(() => {
        if (!newAddress && infosMovingIn) {
            const infosMovingInDto: MovingInFinishDto = JSON.parse(infosMovingIn);
            setNewAddress(
                infosMovingInDto.address?.numeroRue +
                    ' ' +
                    infosMovingInDto.address?.rue +
                    ', ' +
                    infosMovingInDto.address?.codePostal +
                    ' ' +
                    infosMovingInDto.address?.ville
            );
        }
    }, [infosMovingIn, newAddress]);

    /**
     * Changement sur bouton radio
     * @param e Infos du form
     * @param value
     */
    const handlerChangeIsOwner = (e: ChangeEvent<HTMLInputElement>, value: string) => {
        // Avez-vous une factue ? oui ou non
        setIsOwner(value);
        setIsOwnerError(false);
    };

    /**
     * Handle pour le submit du form
     * @param form valeur du form
     */
    const handleSumbitForm = (form: any) => {
        setValidForm(false);
        //control radio btns
        setIsOwnerError(isOwner === '');
        if (isOwner !== '' && infosMovingIn) {
            const infosMovingInDto: MovingInFinishDto = JSON.parse(infosMovingIn);
            infosMovingInDto.isOwner = isOwner === 'owner';
            infosMovingInDto.meterReading =
                form.numberOne?.toString() +
                form.numberTwo?.toString() +
                form.numberThree?.toString() +
                form.numberFour?.toString() +
                form.numberFive?.toString();
            infosMovingInDto.movingInDate = form.movingInDate;
            window.localStorage.setItem('movingInFinish', JSON.stringify(infosMovingInDto));
            navigate('/j-emmenage/etape-trois');
        }
        setValidForm(true);
    };

    return (
        <MovingInStepTwoForm
            handlerChangeIsOwner={handlerChangeIsOwner}
            isOwner={isOwner}
            isOwnerError={isOwnerError}
            handleSumbitForm={handleSumbitForm}
            newAddress={newAddress}
            validForm={validForm}
        />
    );
}
